import { Component, OnInit, ViewChild } from '@angular/core';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DummyRouteService } from 'src/app/service/dummy-route.service';
import { DeleteDummyRouteComponent } from 'src/app/core/dialogs/delete-dummy-route/delete-dummy-route.component';
import { AddDummyRouteComponent } from 'src/app/core/dialogs/add-dummy-route/add-dummy-route.component';
import { MatDialog } from '@angular/material/dialog';
import { RefreshGridComponent } from 'src/app/core/refresh-grid/refresh-grid.component';

export interface DialogData {
  performAction: string;
  placeholder: string;
  page;
}

export interface deleteData {
  id: Number;
  route_name: string;
  page;
}

@Component({
    selector: 'app-dummy-routes',
    templateUrl: './dummy-routes.component.html',
    styleUrls: ['./dummy-routes.component.scss'],
    standalone: false // NOSONAR
})
export class DummyRoutesComponent implements OnInit {

	gridApi: any;
	gridColumnApi: any
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	paginationPageSize: number = 30;
	setPagination = 'true';

  columnDefs;
	icons;
	defaultColDef;

  dynamicHeight: number;
  context: any;
  rowData;
  frameworkComponents;
  rowCount;
  selectedRows: any = [];
  totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 30 , selected : true},
		{value: 50 , selected : false},
	]
	originalPage: any;

  successMessage = '';
  errorMessage = '';

  @ViewChild('agGrid', { static: true }) agGrid

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly dummyRouteService: DummyRouteService, public dialog: MatDialog) {
    this.dynamicHeight = 0.665 * (window.innerHeight);

    this.context = {
      componentParent: this
    };

    this.columnDefs = [
      {
        headerName: "ID", headerClass: "table_id", field: "dummyRouteID", width: 40, 
         sortable: true, unSortIcon: true, autoHeight: true, 
      },
      {
        headerName: "DUMMY ROUTE", headerClass: "dummyRoute", field: "dummyRoute", cellClass: "cell_route", width: 120,
         sortable: true, unSortIcon: true, autoHeight: true
         //, floatingFilterComponentParams: { suppressFilterButton: true }, filter: 'agTextColumnFilter',
      },
      {
        headerName: "DELETE", field: "routes_action",
        width: 40, autoHeight: true, cellRenderer: BtnCellRenderer,
        cellRendererParams: {
          clicked: function (_field: any, _act: any) {
            console.info('some')
          }
        }
      }];

    this.frameworkComponents = {
      btnCellRenderer: BtnCellRenderer
    };

    this.defaultColDef = {
      wrapText: true
    };

    this.icons = {
			sortUnSort: '<img src="./assets/images/unsort.svg">',
		  };
  }

	sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

	onPageSizeChanged(event: any) { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails(); }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

  isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

  rppChanged(event:any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}

  loadData() {
    this.ngxUiLoaderService.start("loader-01");
    //API Integration
    this.rowData = [];
    this.dummyRouteService.getDetails().subscribe(result => {

      console.info("calling getdetails")
      console.info("result", result);

      if (result?.length > 0) {
        this.rowData = result;
        this.rowCount = this.rowData.length;
        if (this.rowData.length) {
					this.totalRecords = this.rowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
        //storing dummyroute data in local
        localStorage.setItem('dummyroute-data', JSON.stringify(result));
      }
      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      this.ngxUiLoaderService.stop("loader-01");
    });
  }

  ngOnInit(): void { // NOSONAR 

    this.ngxUiLoaderService.start("loader-01");
    this.loadData();
  }

  refreshData() {
    this.loadData();
  }

  deleteRow(val) {
    let routeName;
    let id;

    this.rowData.filter(x => x.dummyRouteID == val).forEach(e => {  // NOSONAR
      this.selectedRows.push(e);
      id = e.dummyRouteID;
      routeName = e.dummyRoute;
    });

    const dialogRef = this.dialog.open(DeleteDummyRouteComponent, {
      disableClose: true,
      width: '510px',
      data: { id: id, route_name: routeName, page: 'dummy route' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined) { // NOSONAR
        console.info('The dialog was closed', result);
        console.info("data to be deleted:", result.data);

        const deletejson = {
          "dummyRouteID": result.data,
          "dummyRouteName": routeName
        }

        this.deleteDummyRoute(deletejson);
        console.info("json", deletejson);
      }
    });
  }

  deleteDummyRoute(dataArr) {
    console.info("the delete array in deleterecords", dataArr);
    this.ngxUiLoaderService.start("loader-01");

    this.dummyRouteService.deleteDummyRoute(dataArr).subscribe(_result => {
      this.successMessage = 'Deleted Row(s) Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);

      //fetch latest row data after deleting
      this.loadData();
    });
  }

  addDummyRoute(): void {
    console.info("open dialog");
    const dialogRef = this.dialog.open(AddDummyRouteComponent, {
      disableClose: true,
      width: '410px',
      data: { performAction: 'AddCell', placeholder: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.info('The dialog was closed', result);

      if (result != undefined && result.event == 'AddCell') {  // NOSONAR
        //API Integration
        const dataArr = {
          "dummyRouteID": null,
          "dummyRoute": result.data
        }

        this.ngxUiLoaderService.start("loader-01");
        this.dummyRouteService.addDummyRoute(dataArr).subscribe(result => {

          console.info("result", result);

          if (!result) {
            this.loadData();

            this.errorMessage = 'Dummy Route already exists!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
          else if (result) {
            this.loadData();

            this.successMessage = 'Dummy Route added successfully!';
            setTimeout(() => {
              this.successMessage = '';
              this.errorMessage = '';
            }, 5000);
          }
        });
      }
    });
  }
  
}
